"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'clean',
    name: 'Clean',
    background_color: '#f6f6f6',
    background_image: null,
    background_image_portrait: null,
    heading_font: 'https://fonts.raydiant.com/Roboto-Bold.woff',
    heading_text_color: '#333333',
    heading_2_font: null,
    heading_2_text_color: null,
    body_font: 'https://fonts.raydiant.com/Roboto-Regular.woff',
    body_text_color: '#333333',
    border_color: null,
};
//# sourceMappingURL=clean.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/clean.js